import { render, staticRenderFns } from "./MDetailPrice2.vue?vue&type=template&id=d74faa4a&scoped=true"
import script from "./MDetailPrice2.vue?vue&type=script&lang=js"
export * from "./MDetailPrice2.vue?vue&type=script&lang=js"
import style0 from "./MDetailPrice2.vue?vue&type=style&index=0&id=d74faa4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74faa4a",
  null
  
)

export default component.exports